export function initializeAudioNotice() {
    const notice = document.querySelector('[data-audio-notice]');
    if (!notice) return;
    const title = notice.querySelector('[data-audio-status]');
    const tip = notice.querySelector('[data-audio-tip]');
    const storageKey = 'guitarcharts.audio-reminder-seen';
    let timeout;
    let state;
    let previousFocus;
    let tipSeen = false;
    try {
        tipSeen = sessionStorage.getItem(storageKey) === '1';
    } catch {
        // Storage can be unavailable; retain the preference for this page.
    }
    tip.hidden = tipSeen;

    function dismiss() {
        clearTimeout(timeout);
        if (notice.contains(document.activeElement)) previousFocus?.focus();
        notice.hidden = true;
    }
    function scheduleDismiss() {
        clearTimeout(timeout);
        if (state === 'ready' && !notice.matches(':hover') && !notice.contains(document.activeElement)) {
            timeout = setTimeout(dismiss, tip.hidden ? 4000 : 10000);
        }
    }

    notice.querySelector('button').addEventListener('click', dismiss);
    notice.addEventListener('mouseenter', () => clearTimeout(timeout));
    notice.addEventListener('mouseleave', scheduleDismiss);
    notice.addEventListener('focusin', () => clearTimeout(timeout));
    notice.addEventListener('focusout', () => queueMicrotask(scheduleDismiss));
    notice.addEventListener('keydown', event => {
        if (event.key === 'Escape') dismiss();
    });

    window.addEventListener('guitarcharts:audio-state', event => {
        if (state === 'ready' && event.detail === 'ready') return;
        state = event.detail;
        clearTimeout(timeout);
        if (state === 'loading') {
            const showLoading = () => {
                previousFocus = document.activeElement;
                tip.hidden = tipSeen;
                tipSeen = true;
                try {
                    sessionStorage.setItem(storageKey, '1');
                } catch { /* Session-only fallback above. */ }
                title.textContent = 'Loading guitar sounds…';
                notice.hidden = false;
            };
            // Give cached loads time to finish without flashing a notification.
            if (tipSeen) timeout = setTimeout(showLoading, 400);
            else showLoading();
        } else if (state === 'error') {
            if (notice.hidden) previousFocus = document.activeElement;
            title.textContent = 'Couldn’t start audio. Press play or tap a note to try again.';
            notice.hidden = false;
        } else if (state === 'ready' && !notice.hidden) {
            title.textContent = 'Guitar sounds ready.';
            scheduleDismiss();
        }
    });
}
